import { useEffect, useRef } from 'react';

// TODO check how to apply never or unknown
/* eslint-disable @typescript-eslint/no-explicit-any */
export const useTimeout = <T extends (...args: any[]) => any>(
  fn: T,
  delay: number,
): ((...args: Parameters<T>) => ReturnType<T>) => {
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const cb = (...args: Parameters<T>): ReturnType<T> => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => fn(...args), delay);

    return undefined as unknown as ReturnType<T>;
  };

  useEffect(
    () => () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    },
    [],
  );

  return cb;
};
